import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const JumpToLiveButton = ({ shouldDisplayJumpToLive, translate, jumpToLivePoint, spinnerToggle }) => {
  const theme = useTheme();
  if (!shouldDisplayJumpToLive) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={process.env.PUBLIC_URL + "/images/jump-to-live.svg"}
      alt={translate("jump_to_live")}
      buttonClassName="playbackButton"
      onClickHandler={jumpToLivePoint}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default JumpToLiveButton;
